import { useEffect, useState } from "react"
import AgoraScreenManager from "../Agora/AgoraScreenManager"
import { AgoraManagerType, IAgoraManagerProps } from "../Agora/AgoraManager"

interface IAdditionalRegularDeviceProps
{
    agoraCredentials: IAgoraManagerProps,
    startCommunication?: boolean,
    onError: (error: unknown) => void,
    onStart?: (published: boolean, type: AgoraManagerType, screenId?: string | number) => void,
    onStop?: (type: AgoraManagerType, screenId?: string | number) => void
}

const ScreenShare = (props: IAdditionalRegularDeviceProps) => {
    const { 
        agoraCredentials: credentials, 
        onError
    } = props

    const [agoraManager, setAgoraManager] = useState<AgoraScreenManager>()
    const [startCommunication, setStartCommunication] = useState<boolean>(false)

    useEffect(() => {
        if(!agoraManager)
        {
            console.log("Add screen share")
    
            const am = new AgoraScreenManager(credentials)
            am.initialize({}).then(() => {
                console.debug("Share screen manager initialized")
                setAgoraManager(am)
                setStartCommunication(true)
            })
        }

        return () => {
            if(!agoraManager) return

            console.log("Stop screen sharing")
            if(props.onStop)
                props.onStop("screen")

            agoraManager.destroy()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [agoraManager])

    useEffect(() => {
        if(!startCommunication) return
        if(!agoraManager?.tracks) return
        if(!credentials.appId) return
        if(!credentials.channel) return
        if(!credentials.token) return
        
        const init = async(name: string, mng: AgoraScreenManager) => {
            if(!credentials.appId) return
            if(!credentials.token) return
            if(!mng?.client) return undefined;
            if(!mng?.tracks) return undefined;
            
            const track = mng.getLocalVideoTrack()
            if(!track) return

            const uid = "track_" + track.getTrackId()

            track.on("track-ended", () => {
                console.debug("Share screen track ended >>")
                onError("TRACK_ENDED")
            })

            await mng.client.join(credentials.appId, name, credentials.token, uid);
            mng.client.publish(track).then(() => {
                if(props.onStart)
                    props.onStart(true, "screen")
            });
        }

        init(credentials.channel, agoraManager)
            .catch(err => onError(err));
    }, [agoraManager, startCommunication])

    return (null)
}

export default ScreenShare
